import { environment } from '../../../environments/environment';

/**
 * Socket.IO handshake options for prism-new, which serves its socket on the API's own path and
 * refuses a handshake that carries no session bearer.
 */
export interface PrismNewSocketOptions {
  readonly path: string;
  readonly auth: (cb: (data: { token?: string }) => void) => void;
}

/**
 * Builds the handshake options from a token reader. `auth` is a function rather than a value so
 * every reconnect presents the token current at that moment, not the one minted at page load.
 */
export function prismNewSocketOptions(readToken: () => string | null): PrismNewSocketOptions {
  return {
    path: environment.prismNew.socketPath,
    auth: (cb) => {
      const token = readToken();
      cb(token ? { token } : {});
    },
  };
}
